<template>
    <div class="settle-content">
        <div class="title">欢迎入驻法行宝</div>
        <veui-form
            ref="form"
            :data="formData"
        >
            <veui-field
                name="name"
                label="律师姓名"
                :rules="[{name: 'required', value: true}]"
            >
                <veui-input
                    v-model="formData.name"
                    placeholder="请输入律师姓名"
                    autocomplete="off"
                />
            </veui-field>
            <veui-field
                name="registerId"
                label="律师执业资格证号"
                :rules="[
                    {name: 'required', triggers: 'blur'},
                    {
                        name: 'pattern',
                        value: /^(\d{17})$/,
                        message: '您填写的律师执业资格证号有误，请检查后重填',
                        triggers: 'blur',
                    },
                ]"
            >
                <veui-input
                    v-model="formData.registerId"
                    placeholder="请输入律师执业资格证号"
                    autocomplete="off"
                />
            </veui-field>
            <veui-field
                name="city"
                label="从业地区"
                :rules="[{name: 'required', value: true}]"
            >
                <Cascader
                    v-model="formData.city"
                    :data="cityOptions"
                    class="city-option"
                    clearable
                />
            </veui-field>
            <veui-field
                name="phone"
                label="律师电话"
                :rules="[{name: 'required', value: true}]"
            >
                <veui-input
                    v-model="formData.phone"
                    placeholder="请输入律师电话"
                    autocomplete="off"
                />
            </veui-field>
            <veui-field
                name="code"
                label="验证码"
                :rules="[{name: 'required', value: true}]"
            >
                <veui-input
                    v-model="formData.code"
                    class="verify-code-input"
                    placeholder="请输入验证码"
                    autocomplete="off"
                />
                <div class="verify-btn" @click.stop="getSmsCode">{{ smsBtnText }}</div>
            </veui-field>
            <veui-field
                class="form-agree"
                name="isAgree"
                field="isAgree"
                :rules="[{name: 'required', value: true, message: '请勾选阅读协议'}]"
                label=""
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null">我已阅读并知晓 </veui-checkbox>
                <span class="form-href-terms" @click.stop="goto('serve')">《律师入驻服务条款》</span>
                <span class="form-href-terms" @click.stop="goto('agree')">《信息真实承诺书》</span>
                <span class="form-href-terms" @click.stop="goto('phone')">《联系方式授权协议》</span>
            </veui-field>
        </veui-form>
        <div class="button-wrap">
            <veui-button
                ui="primary"
                :loading="submitLoading"
                @click="submit"
            >
                立即入驻
            </veui-button>
        </div>
        <!-- 入驻失败弹框 -->
        <confirmDialog
            v-if="isShowDialog && dialogContent.length"
            title="入驻提交失败"
            confirm-btn="我知道了"
            :is-show-cancel-btn="false"
            :is-default-content="false"
            :is-show-close-icon="true"
            @confirm="isShowDialog = false"
            @cancel="isShowDialog = false"
        >
            <div v-for="item, index in dialogContent" :key="index">{{ item }}</div>
        </confirmDialog>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 律师入驻
 * @author <lice02@baidu.com>
*/

import {Button, Form, Field, Input, Checkbox} from 'veui';
import isBoolean from 'lodash/isBoolean';
import $http from '@/utils/ajax.js';
import confirmDialog from '../../../components/confirm-dialog.vue';
import {withBase} from '@/utils/basePath';

export default {
    data() {
        return {
            cityOptions: [],
            formData: {
                name: '',
                phone: '',
                registerId: '',
                city: [],
                code: '',
                isAgree: null
            },
            submitLoading: false,
            smsBtnText: '发送验证码',
            isGetSmsCode: false,
            isShowDialog: false, // 展示提交失败弹框
            dialogContent: []
        };
    },
    components: {
        'veui-button': Button,
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-checkbox': Checkbox,
        confirmDialog
    },
    created() {
        document.body.style.background = '#f6f7fa';
    },
    mounted() {
        this.getCity();
        this.$wywLog.addKey({
            page: 'lawsettle',
            fr: this.$route.query.from || ''
        });
        if (this.$route.query.qcno) {
            this.formData = {
                ...this.formData,
                name: this.$route.query.name,
                registerId: this.$route.query.qcno
            };
        }
        // 页面pv打点
        this.$wywLog.send({
            serverId: 16208,
            area: 'pv',
            action: 'pv'
        });
    },
    methods: {
        axiosRequest(options = {}) {
            return new Promise((resolve, reject) => {
                let result = {
                    status: 0,
                    data: {},
                    msg: ''
                };
                if (!options.url) {
                    return;
                }

                $http(options).then(res => {
                    const resData = res || {};
                    result.data = resData.data;
                    result.status = resData.status;
                    result.msg = resData.msg;
                    resolve(result);
                }).catch(err => {
                    result.msg = err && err.msg || '网络错误';
                    reject(result);
                });
            });
        },

        // 获取全国城市数据
        getCity() {
            this.$http.get('/bp/api/city/cityAll', {
            }).then(res => {
                if (!res || +res.code !== 0) {
                    return;
                }
                let data = res.data;
                if (data) {
                    this.cityOptions = data;
                }
            }).catch(err => this.$normalizeResponseError(err));
        },

        // 阅读协议
        goto(type) {
            if (type === 'serve') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/lawyer_rule.pdf');
            }
            else if (type === 'agree') {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf');
            }
            else if (type === 'phone') {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/phone_apply_rule.pdf');
            }
        },

        // 提交表单
        submit() {
            this.$refs.form.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    if (this.submitLoading) {
                        return;
                    }
                    this.submitLoading = true;
                    this.$http.post('/bp/api/user/init', {
                        name: this.formData.name,
                        register_id: this.formData.registerId,
                        register_region: this.formData.city?.join('$'),
                        mobile_number: this.formData.phone,
                        code: this.formData.code,
                        type: 'settle_in',
                        fr: this.$route.query.fr || 'fill_data'
                    }).then(res => {
                        this.submitLoading = false;
                        if (+res.code === 0) {
                            // 提交成功，跳转到认证引导页
                            this.$Message.success('提交成功');
                            // 律师入驻页面立即入驻按钮点击打点
                            this.$wywLog.send({
                                serverId: 16208,
                                area: 'ljzc_succ',
                                action: 'click'
                            });
                            this.$http.get('/bp/api/user/count');
                            setTimeout(() => {
                                window.location.href = withBase('/lawinfo/lawverifyguide') + '?form=law-settle';
                            }, 500);
                            return;
                        }
                        if (+res.code === 8006) {
                            // 弹窗提示
                            this.dialogContent = res.msg ? res.msg.split('</br>') : [];
                            this.isShowDialog = true;
                            return;
                        }
                        this.$Message.error(res.msg || '提交失败, 请稍后重试！');
                    }).catch(err => {
                        this.submitLoading = false;
                        this.$Message.error('网络错误，请稍后重试！');
                    });
                }
                else {
                    if (!this.formData.isAgree) {
                        this.$Message.error('请先阅读并同意法行宝律师入驻相关协议内容');
                        return;
                    }
                    if (this.formData.registerId && this.formData.registerId.length !== 17) {
                        this.$Message.error(`您填写的${this.formData.registerId}有误，请检查后重填`);
                        return;
                    }
                    this.$Message.error('有必填字段未填写，请完善后再提交');
                }
            });
        },

        // 获取手机验证码
        async getSmsCode() {
            if (this.isGetSmsCode) {
                return;
            }
            if (!this.formData.phone) {
                this.$Message.error('律师手机号不能为空');
                return;
            }
            if (/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.formData.phone) === false) {
                this.$Message.error('手机号格式错误');
                return;
            }
            this.isGetSmsCode = true;
            await this.$http.get('/falv/common/sendcode', {
                params: {
                    phone: this.formData.phone,
                    type: 'settle_in',
                    required: true
                }
            }).then(res => {
                if (+res.code === 0) {
                    // 按钮倒计时禁用(59秒)
                    this.$Message.success('验证码发送成功');
                    let disableTime = 59000;
                    const step = 1000;
                    this.smsBtnText = `${disableTime / 1000 }s`;
                    const t = setInterval(() => {
                        if (disableTime - step > 0) {
                            disableTime = disableTime - step;
                            let countDown = (disableTime / 1000).toFixed();
                            !countDown[1] && (countDown = '0' + countDown);
                            this.smsBtnText = `${countDown}s`;
                        }
                        else {
                            this.isGetSmsCode = false;
                            this.smsBtnText = '重新发送';
                            clearInterval(t);
                        }
                    }, 1000);
                }
                else {
                    this.isGetSmsCode = false;
                    this.$Message.error(res.msg || '网络不给力');
                }
            })
                .catch(err => {
                    this.isGetSmsCode = false;
                    this.$Message.error('网络不给力');
                });
        }
    }
};
</script>
<style lang="less" scoped>
    .settle-content {
        width: 698px;
        margin: 0 auto;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            line-height: 18px;
            margin-bottom: 65px;
            text-align: center;
        }

        ::v-deep .veui-field {
            margin-bottom: 30px;

            .veui-field-label {
                width: 134px;
            }

            .veui-field-content {
                height: 40px;
            }

            .veui-input {
                width: 530px;
                height: 40px;
                border: 1px solid #e9ecf3;
                border-radius: 8px;

                &-placeholder {
                    color: #999;
                }
            }

            .veui-focus {
                border: 1px solid #3855d5;
                border-radius: 5px;
                box-shadow: unset;
            }

            .verify-code-input {
                top: 0;
                left: 0;
            }

            .verify-btn {
                position: absolute;
                top: 13px;
                right: 0;
                width: 106px;
                height: 16px;
                font-size: 14px;
                color: #3e4cff;
                line-height: 16px;
                border-left: 1px solid #d8d8d8;
                text-align: center;
                cursor: pointer;
            }
        }

        ::v-deep .ivu-cascader {
            width: 530px;
            height: 40px;

            .ivu-input {
                border: 1px solid #e9ecf3;
                border-radius: 8px;
            }
        }

        ::v-deep .veui-invalid .veui-input {
            border-color: #cc1800;
        }

        ::v-deep .veui-invalid .ivu-input {
            border-color: #cc1800;
        }

        .form-agree {
            margin-left: calc(7em + 70px);
            margin-top: -9px;

            .form-href-terms {
                cursor: pointer;
            }
        }

        .button-wrap {
            margin: 74px 0 30px;
            text-align: center;
        }
    }
</style>
